export function TOKEN_GETTER() {
  return localStorage.getItem('access_token');
}
